export default __webpack_public_path__ + "img/95aa47b5a754f6e830a3ab2931dd5816.svg";